import React from 'react';

interface AdminDashboardTableHitsInterface {
  hits: any, // TODO: update `any`
  Hit: React.FC<any>,
  selected: Array<number>,
  toggleSelected: (id: number) => void,
  canDelete?: boolean,
  canSetExpiration?: boolean,
  canEdit?: boolean,
  allowBulkSelect?: boolean,
  trackSelected?: Array<any>,
  setTrackedSelected?: (selected: Array<any>) => void,
  editCallback?: Function,
  formTypeFromUrl?: string,
  userIsApprovedSeller?: boolean,
}

const AdminDashboardTableHits: React.FC<AdminDashboardTableHitsInterface> = ({
  hits,
  Hit,
  selected,
  toggleSelected,
  canDelete,
  canSetExpiration,
  canEdit,
  allowBulkSelect,
  trackSelected,
  setTrackedSelected,
  editCallback,
  formTypeFromUrl,
  userIsApprovedSeller,
}) => {
  return (
    <>
      {hits.map((hit) => (
        <Hit
          key={hit.objectID}
          selected={selected}
          toggleSelected={toggleSelected}
          canDelete={canDelete}
          canSetExpiration={canSetExpiration}
          canEdit={canEdit}
          allowBulkSelect={allowBulkSelect}
          trackSelected={trackSelected}
          setTrackedSelected={setTrackedSelected}
          editCallback={editCallback}
          formTypeFromUrl={formTypeFromUrl}
          userIsApprovedSeller={userIsApprovedSeller}
          {...hit}
        />
      ))}
    </>
  );
};

AdminDashboardTableHits.defaultProps = {
  allowBulkSelect: true,
};

export default AdminDashboardTableHits;
